const CompanyIcon = () => (
  <div>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.16666 12.832H12.8333"
        stroke="#A0CBFE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.91667 1.16797H4.08333C2.33333 1.16797 1.75 2.21214 1.75 3.5013V12.8346H12.25V3.5013C12.25 2.21214 11.6667 1.16797 9.91667 1.16797Z"
        stroke="#A0CBFE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.08334 9.625H5.83334"
        stroke="#A0CBFE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16666 9.625H9.91666"
        stroke="#A0CBFE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.08334 7H5.83334"
        stroke="#A0CBFE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16666 7H9.91666"
        stroke="#A0CBFE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.08334 4.375H5.83334"
        stroke="#A0CBFE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16666 4.375H9.91666"
        stroke="#A0CBFE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default CompanyIcon;
